// MinimalRoutes.tsx
import { Suspense, lazy } from 'react';
import MinimalLayout from '@/components/layout/MinimalLayout/MinimalLayout';
import RoleProtectedRoute from '@/context/RoleProtectedRoute';
import { USER_ROLE_ADMIN, USER_ROLE_CREATOR, USER_ROLE_USER } from '@/models/User';

// Internal chat interface
const InternalChatPage = lazy(() => import('../pages/InternalChat/ChatInterfacePage'));

const MinimalRoutes = {
    path: '/',
    element: (
        <RoleProtectedRoute allowedRoles={[USER_ROLE_ADMIN, USER_ROLE_CREATOR, USER_ROLE_USER]}>
            <MinimalLayout />
        </RoleProtectedRoute>
    ),
    children: [
        {
            path: 'chat',
            element: (
                <Suspense>
                    <InternalChatPage />
                </Suspense>
            )
        }
    ]
};

export default MinimalRoutes; 